import { DIMENSIONS, DIMENSION_META, type Dimension } from './dimensions';

/** The weight the ENGINE used for this report, per dimension, 0-100. */
export type StageWeights = Record<Dimension, number>;

const DIMENSION_BY_LABEL = new Map<string, Dimension>(
  DIMENSIONS.map((dimension) => [DIMENSION_META[dimension].label, dimension] as const),
);

function isCompleteStageWeights(weights: Partial<StageWeights>): weights is StageWeights {
  return DIMENSIONS.every((dimension) => typeof weights[dimension] === 'number');
}

/** Reads the per-dimension stage weights out of a scoring export's rationale rows. */
export function stageWeightsFromExport(
  exp: { rationale_rows?: Array<Record<string, string | number>> } | null | undefined,
): StageWeights | null {
  if (!exp?.rationale_rows?.length) return null;

  const weights: Partial<StageWeights> = {};
  for (const row of exp.rationale_rows) {
    const label = row.Dimension;
    if (typeof label !== 'string') continue;
    const dimension = DIMENSION_BY_LABEL.get(label);
    if (!dimension) continue;

    const rawWeight = row['Stage Weight (%)'];
    if (typeof rawWeight !== 'number' && typeof rawWeight !== 'string') return null;
    if (typeof rawWeight === 'string' && rawWeight.trim() === '') return null;
    const weight = typeof rawWeight === 'number' ? rawWeight : Number(rawWeight);
    if (!Number.isFinite(weight) || weight < 0) return null;
    weights[dimension] = weight;
  }

  return isCompleteStageWeights(weights) ? weights : null;
}
